export default {
  instruction: `
    Reproduzca el vídeo para saber más sobre la vacuna contra el coronavirus.
  `,
  done: `
    Pulse el botón <b>Terminado</b> cuando haya terminado.
  `,
};
